module.exports = __webpack_public_path__ + "img/camp.04a1349d.png";